function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6147 34.8625H16.1517C15.5331 34.8625 15.0629 34.3065 15.1656 33.6965L17.1093 22.1531C17.3 21.0207 18.9371 21.0501 19.0869 22.1886L20.6062 33.732C20.685 34.331 20.2188 34.8625 19.6147 34.8625Z",
  fill: "#FFD600"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9642 12.6676C20.1067 15.1142 19.871 19.057 18.2616 19.3311C18.1424 19.3514 18.0193 19.3377 17.9026 19.3058C15.9462 18.7702 16.0887 15.6515 16.1964 12.6676C16.3072 9.59619 17.1937 5.84619 18.0803 5.84619C18.9668 5.84619 19.8164 10.1319 19.9642 12.6676Z",
  fill: "#FFD600"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5626 21.621C12.6312 20.2661 16.1887 18.4768 17.2241 19.6855C17.3055 19.7805 17.3564 19.8981 17.3864 20.0195C17.8624 21.9422 15.0661 23.3961 12.4045 24.8114C9.66042 26.2706 5.94278 27.4161 5.50938 26.6654C5.07597 25.9147 8.41403 23.0283 10.5626 21.621Z",
  fill: "#FFD600"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7285 24.755C21.5208 23.641 18.1924 21.4548 18.7215 19.9537C18.7631 19.8358 18.8395 19.7329 18.9296 19.6461C20.3568 18.2726 23.014 19.9673 25.5705 21.5647C28.2062 23.2115 31.057 25.8584 30.6236 26.609C30.1902 27.3597 26.0215 25.9121 23.7285 24.755Z",
  fill: "#FFD600"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.071,
  cy: 19.5,
  r: 2,
  fill: "#FFD600",
  stroke: "#21334F"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M0.891671 11.4583L7.32114 2.0428C7.50479 1.77386 7.9252 1.94911 7.86345 2.26886L6.66569 8.47098C6.62995 8.65606 6.77174 8.82786 6.96025 8.82786H11.0104C11.2501 8.82786 11.393 9.09503 11.26 9.29439L3.81769 20.4463C3.63172 20.725 3.19821 20.5355 3.27644 20.2097L5.17668 12.2976C5.22199 12.1089 5.079 11.9275 4.88498 11.9275H1.13942C0.898296 11.9275 0.755696 11.6574 0.891671 11.4583Z",
  fill: "#FFD600"
});

function SvgPower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.a4e0eb3f.svg";
export { ForwardRef as ReactComponent };